<template>
  <v-container fluid>
    <!-- Navbar -->
    <v-app-bar color="primary" dark>
      <v-toolbar-title>Receive Files</v-toolbar-title>
    </v-app-bar>

    <!-- Files Card -->
    <v-card class="mt-4">
      <v-card-title class="justify-center">📥 Files Available</v-card-title>
      <v-card-text>
        <div v-if="loading" class="text-center">
          <v-progress-circular indeterminate color="blue"></v-progress-circular>
          <p>Loading files...</p>
        </div>

        <v-list v-else>
          <v-slide-group show-arrows>
            <v-slide-item
              v-for="file in files"
              :key="file.id"
              class="swipeout-item"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>📄 {{ file.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ file.size }} • {{ file.date }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn color="blue" @click="downloadFile(file)" small>Download</v-btn>
                  <v-btn color="red" @click="deleteFile(file)" small>Delete</v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-slide-item>
          </v-slide-group>
        </v-list>

        <div v-if="!files.length && !loading" class="text-center text-grey--text">
          <p>No files available for download.</p>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: 'DownloadView',
  data() {
    return {
      loading: true,
      files: []
    }
  },
  mounted() {
    setTimeout(() => {
      this.files = [
        { id: 1, name: 'Report.pdf', size: '1.2 MB', date: '2025-07-18' },
        { id: 2, name: 'Photo.zip', size: '3.4 MB', date: '2025-07-17' }
      ]
      this.loading = false
    }, 1500)
  },
  methods: {
    downloadFile(file) {
      alert(`Downloading ${file.name}`)
    },
    deleteFile(file) {
      this.files = this.files.filter(f => f.id !== file.id)
      alert(`${file.name} deleted`)
    }
  }
}
</script>
<style scoped>
.swipeout-item {
  margin-bottom: 8px;
}
.text-center {
  text-align: center;
}
</style>
